/**
 * Wrightsock: prepend "From" on Globo instant-search product cards
 * when the product is on sale (has a compare-at / old price).
 *
 * Globo's built-in template only renders:
 *   .gl-card-price + optional .gl-card-old-price
 * There is no app setting for a "From" prefix.
 */
(function () {
  if (window.__wsGloboSearchFrom) return;
  window.__wsGloboSearchFrom = true;

  var FROM_PREFIX = 'From ';

  function decorateCard(card) {
    var pricing = card.querySelector('.gl-card-pricing');
    if (!pricing) return;

    var oldPrice = pricing.querySelector('.gl-card-old-price');
    var price = pricing.querySelector('.gl-card-price');
    if (!price || !oldPrice) return;

    var text = (price.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || /^from\b/i.test(text)) return;

    price.textContent = FROM_PREFIX + text;
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.classList && root.classList.contains('gl-product-card')) {
      decorateCard(root);
    }
    var cards = root.querySelectorAll ? root.querySelectorAll('.gl-product-card') : [];
    for (var i = 0; i < cards.length; i++) decorateCard(cards[i]);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
